import advisorProfileLists from './advisorProfileLists'
import clientProfileLists from './clientProfileLists'
import collaboratorProfileLists from './collaboratorProfileLists'

const permissionsLists = {
  advisorProfileLists,
  collaboratorProfileLists,
  clientProfileLists,
}

export default permissionsLists
